var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#225ea8}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m17.8 6.8l-4.6-4.6 1.5-1.6q0.6-0.6 1.6-0.6 0.9 0 1.5 0.6l1.5 1.6q0.7 0.6 0.7 1.5 0 0.9-0.6 1.5zm-16.7 13.2q-0.5 0-0.8-0.3-0.3-0.3-0.3-0.8v-3.1q0-0.2 0-0.4 0.1-0.2 0.3-0.3l11.3-11.3 4.6 4.6-11.3 11.3q-0.1 0.2-0.3 0.3-0.2 0-0.5 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.89891e081d603945afcadbf849d1fdb6.svg";
export { ForwardRef as ReactComponent };